import Card from './Card'
import { Label } from './Field'
import { Pix } from '~/icons'

export default function ContentPix() {
  return (
    <Card color="secondary">
      <Pix className="fill-primary-success text-xl" />
      <h2 className="font-medium">Pague com Pix, direto do seu celular.</h2>
      <Label>Aperte em Finalizar compra para gerar o código QR.</Label>
      <Label>Confira os dados e realize o pagamento pelo app do seu banco.</Label>
    </Card>
  )
}
